import { apiClient } from "@/api/client";
import { API_ENDPOINTS } from "@/config/app";
import type { PaginatedResponse, PaginationParams } from "@/types/api";
import { buildUrl } from "@/utils/buildUrl";

import type { OptionItemWithChildren } from "../types";
import type {
  BranchId,
  GoogplePlaceId,
  IBranch,
  IBranchFull,
  IBranchInfo,
  IBranchPaylad,
} from "./types";

export const branchesApi = {
  async postNewBranch(brandData: IBranch) {
    const response = await apiClient.post<IBranchFull>(
      `${API_ENDPOINTS.ADMIN}/branches`,
      brandData
    );
    return response;
  },

  async getAllBranches(
    params?: PaginationParams
  ): Promise<PaginatedResponse<IBranchInfo>> {
    const url = buildUrl(API_ENDPOINTS.ADMIN, "/branches", params);

    const response = await apiClient.get<PaginatedResponse<IBranchInfo>>(url);
    return response;
  },

  async patchBranch(branchId: BranchId, brandData: Partial<IBranchPaylad>) {
    const response = await apiClient.patch(
      `${API_ENDPOINTS.ADMIN}/branches/${branchId}`,
      brandData
    );
    return response;
  },

  async deleteBranch(branchId: BranchId) {
    const response = await apiClient.delete(
      `${API_ENDPOINTS.ADMIN}/branches/${branchId}`
    );
    return response;
  },

  async getBranchById(branchId: BranchId): Promise<IBranchFull> {
    const response = await apiClient.get<IBranchFull>(
      `${API_ENDPOINTS.ADMIN}/branches/${branchId}`
    );
    return response;
  },

  async getBranchAvailableLegalEntityByBrandId(
    brandId: string
  ): Promise<OptionItemWithChildren[]> {
    const response = await apiClient.get<OptionItemWithChildren[]>(
      `${API_ENDPOINTS.ADMIN}/branches/available-legal-entities/${brandId}`
    );
    return response;
  },

  async getBranchByGooglePlaceId(
    googlePlaceID: GoogplePlaceId
  ): Promise<IBranch> {
    const response = await apiClient.get<IBranch>(
      `${API_ENDPOINTS.ADMIN}/branches/google-place/${googlePlaceID}`
    );
    return response;
  },
};
